export const matchApi = api => ({
  create(
    league,
    homeTeam,
    awayTeam,
    matchDate,
    homeContent,
    homeContentEn,
    awayContent,
    awayContentEn,
    slug,
    slugEn,
    isShowHome,
    title,
    titleEn,
    description,
    descriptionEn,
    cover,
    isShowSlider,
    isFeaturedMatch,
    homeOrder,
    sliderOrder,
    featuredMatchOrder,
    site,
    siteContent,
    siteContentEn,
    isPublished,
    homeScore,
    awayScore,
    homeSummary,
    homeSummaryEn,
    awaySummary,
    awaySummaryEn,
    isEditorChoice
  ) {
    return api.post('/match/create', {
      league,
      homeTeam,
      awayTeam,
      matchDate,
      homeContent,
      homeContentEn,
      awayContent,
      awayContentEn,
      slug,
      slugEn,
      isShowHome,
      title,
      titleEn,
      description,
      descriptionEn,
      cover,
      isShowSlider,
      isFeaturedMatch,
      homeOrder,
      sliderOrder,
      featuredMatchOrder,
      site,
      siteContent,
      siteContentEn,
      isPublished,
      homeScore,
      awayScore,
      homeSummary,
      homeSummaryEn,
      awaySummary,
      awaySummaryEn,
      isEditorChoice
    });
  },
  list(page) {
    return api.get(`/match/list/${page}`);
  },
  archive(page) {
    return api.get(`/match/archive/${page}`);
  },
  get(id) {
    return api.get(`/match/${id}`);
  },
  update(
    league,
    homeTeam,
    awayTeam,
    matchDate,
    homeContent,
    homeContentEn,
    awayContent,
    awayContentEn,
    slug,
    slugEn,
    isShowHome,
    title,
    titleEn,
    description,
    descriptionEn,
    cover,
    isShowSlider,
    isFeaturedMatch,
    homeOrder,
    sliderOrder,
    featuredMatchOrder,
    site,
    siteContent,
    siteContentEn,
    isPublished,
    homeScore,
    awayScore,
    homeSummary,
    homeSummaryEn,
    awaySummary,
    awaySummaryEn,
    isEditorChoice,
    id
  ) {
    return api.post(`/match/update/${id}`, {
      league,
      homeTeam,
      awayTeam,
      matchDate,
      homeContent,
      homeContentEn,
      awayContent,
      awayContentEn,
      slug,
      slugEn,
      isShowHome,
      title,
      titleEn,
      description,
      descriptionEn,
      cover,
      isShowSlider,
      isFeaturedMatch,
      homeOrder,
      sliderOrder,
      featuredMatchOrder,
      site,
      siteContent,
      siteContentEn,
      isPublished,
      homeScore,
      awayScore,
      homeSummary,
      homeSummaryEn,
      awaySummary,
      awaySummaryEn,
      isEditorChoice
    });
  },
  delete(id) {
    return api.delete(`/match/delete/${id}`);
  },
  changeArchive(id, archived) {
    return api.post(`/match/change-archive/${id}`, {
      archived
    });
  }
});
